import {computed} from '@api'
import {VipLocalStore} from '@modules'
import {GroupByRowPageStore, GroupByColumnPageStore, GroupByPageIndividualStore} from '@modules/pdf'
import {StoresInstance} from '@stores'

export interface GroupByPagesProps {
  data?: any
  download?: boolean
}

export interface IGroupsPerPage {
  pageIndex: number
  data: Array<any>
  group: Array<any>
  complete?: boolean
}

export interface IPageColumn {
  pageIndex: number
  columns: Array<any>
  rows: Array<any>
  complete: boolean
  groupName: string
}

export class GroupByPagesStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: GroupByPagesProps) {
    super(stores)
  }

  get total() {
    const {props: {data}} = this
    return data.total
  }

  get layout() {
    const {pdf: {config: {layout}}} = this
    return layout
  }

  get data() {
    const {props: {data}} = this
    return data
  }

  get queryLimit() {
    const {pdf: {config: {queryLimit}}} = this
    return queryLimit
  }

  @computed get maxLimit() {
    const {catalog: {itemCount}, queryLimit} = this
    return itemCount > queryLimit ? queryLimit : itemCount
  }

  get groups() {
    const {data, layout, secondGrouping} = this
    return (layout === 'column' || !secondGrouping) ? data.groups : data.groups.reduce((acc, group) => {
      if (!group) return acc
      return [
        ...acc,
        ...group.children.map(child => {
          return {...group, items: {...(group?.items ?? {}), items: [...(child?.items?.items ?? [])]}, spec: [{...child, spec: true}]}
        })
      ]
    }, [])
  }

  get rowsPerPage() {
    const {pdf: {rowsPerPage}} = this
    return rowsPerPage
  }

  @computed get grouping() {
    const {pdf: {grouping}} = this
    return grouping
  }

  @computed get secondGrouping() {
    const {groupBy: {hierarchyGroups}} = this
    return hierarchyGroups[1]
  }

  @computed get size() {
    const {pdf: {itemsPerRow}} = this
    return itemsPerRow === 1 ? itemsPerRow : itemsPerRow - 1
  }

  @computed get pages() {
    const {catalog} = this
    let store
    if (this.secondGrouping === undefined || (this.layout !== 'column' && this.secondGrouping)) {
      store = new GroupByRowPageStore(catalog.stores, this)
    }
    if (this.secondGrouping !== undefined && this.layout === 'column') {
      store = new GroupByColumnPageStore(catalog.stores, this)
    }
    return store?.pages ?? []
  }
}


// WEBPACK FOOTER //
// ./src/modules/pdf/templates/vlp/GroupByPagesStore.ts